var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 19.6544L0.0105418 19.6289L0.0115001 32.1364L14.375 34.172V19.6544ZM16.2917 19.6583V34.4438L36.4119 37.2949L36.4167 19.6937L16.2917 19.6583ZM14.375 3.19559L0 5.28018L0.0134166 17.666H14.375V3.19559ZM16.2917 2.91784V17.666H36.4119V0L16.2917 2.91784Z",
    fill: "#00B0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoft);
export default __webpack_public_path__ + "static/media/icon-microsoft.c9caf10dc71d7ff6cba8b7ee721cde5b.svg";
export { ForwardRef as ReactComponent };